export const formatErpMoney = (amount, symbol = "C$") => {
  const num = parseFloat(amount) || 0;
  const formatted = new Intl.NumberFormat("es-NI", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(num);
  return `${symbol || "C$"}${formatted}`;
};

export default formatErpMoney;
